import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AutoBIMLogo, Wordmark } from "@/components/Brand";

function LegalShell({ title, children }) {
  return (
    <div className="min-h-screen abl-grid-bg">
      <header className="flex items-center justify-between border-b border-border bg-background/85 px-5 py-3 backdrop-blur">
        <Link to="/landing" className="flex items-center gap-2.5"><AutoBIMLogo size={30} /><Wordmark small /></Link>
      </header>
      <div className="mx-auto max-w-3xl px-5 py-10">
        <h1 className="mb-6 text-2xl font-black">{title}</h1>
        <div className="space-y-4 text-sm leading-relaxed text-muted-foreground">{children}</div>
      </div>
    </div>
  );
}

export default function Privacy() {
  const { lang } = useAuth();
  const isAr = lang === "ar";
  return (
    <LegalShell title={isAr ? "سياسة الخصوصية" : "Privacy Policy"}>
      <p>{isAr ? "نحترم خصوصيتك. لا نبيع بياناتك لأي طرف ثالث. تُستخدم بياناتك فقط لتقديم خدمة توليد المخططات المعمارية وإدارة حسابك واشتراكك." : "We respect your privacy. We never sell your data. Your data is used only to provide the architectural plan generation service and to manage your account and subscription."}</p>
      <p>{isAr ? "تُخزَّن المشاريع والمخططات على خوادمنا الآمنة وتُربط بحسابك فقط. يمكنك حذف حسابك وكل بياناته في أي وقت من صفحة الحساب." : "Projects and plans are stored securely and linked only to your account. You can delete your account and all its data at any time from the Account page."}</p>
      <p>{isAr ? "نستخدم بصمة جهاز مجهولة للحد من إساءة الاستخدام وإدارة الأجهزة المسموح بها لكل حساب." : "We use an anonymous device fingerprint to limit abuse and manage the number of allowed devices per account."}</p>
    </LegalShell>
  );
}
